'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isInteger = {};

exports.__exports = isInteger;
